import BIProbeDetail from "../../../model/design/taskDatas/bi/BIProbeDetail";
import ProcessStore from "./ProcessStore";

export default class BiProbeDetailStore extends ProcessStore<BIProbeDetail> {
    constructor () {
        super();
        this.taskData.detail = new BIProbeDetail();
    }
}